import React from "react";
import { ModalFooter } from "reactstrap";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type Props = {
    cancelLabel: string;
    validateLabel: string;
    onCancel: () => void;
    onValidate: () => void;
};

export function ArchiveFooter({
    cancelLabel,
    validateLabel,
    onCancel,
    onValidate,
}: Props) {
    return (
        <ModalFooter className="border-top-0">
            <CustomSecondaryColorButton
                data-testid="fidelity-archive-cancel-button"
                outline
                variant="light"
                onClick={onCancel}
                rounded
            >
                {cancelLabel}
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                data-testid="fidelity-archive-validate-button"
                rounded
                className="mr-2"
                variant="primary"
                onClick={onValidate}
            >
                {validateLabel}
            </CustomMainColorButton>
        </ModalFooter>
    );
}
